import type { Properties } from 'posthog-js';
import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

type CaptureProperties = Properties & {
  errorType: string;
};

// PostHog error tracking reads severity from `$exception_level`. Report expected
// failures as `warning` so they stay out of the `error` feed.
type CaptureLevel = 'error' | 'warning';

export const useCaptureError = () => {
  const posthog = usePostHog();

  const captureError = useCallback(
    (
      error: unknown,
      additionalProperties?: CaptureProperties,
      level: CaptureLevel = 'error',
    ) => {
      const exception =
        error instanceof Error
          ? error
          : new Error(
              error
                ? String(error)
                : 'No error provided. Please provide an error.',
            );

      posthog.captureException(exception, {
        ...additionalProperties,
        $exception_level: level,
      });
    },
    [posthog],
  );

  return captureError;
};
